/**
 * @generated SignedSource<<705f541a158a1e0ed8dbc4d2391eabf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatButton_ChatThread$data = {
  readonly chatMessages: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly unreadMessages: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ChatButton_ChatThread";
};
export type ChatButton_ChatThread$key = {
  readonly " $data"?: ChatButton_ChatThread$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatButton_ChatThread">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatButton_ChatThread",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "unreadMessages",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "unread": true
          }
        }
      ],
      "concreteType": "ChatMessageConnection",
      "kind": "LinkedField",
      "name": "chatMessages",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "chatMessages(filters:{\"unread\":true})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatMessageConnection",
      "kind": "LinkedField",
      "name": "chatMessages",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ChatThread",
  "abstractKey": null
};
})();

(node as any).hash = "84616d9867d8e9d63c8e260f247de751";

export default node;
